import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { TextInput } from '../../../../Helpers/Inputs';
import InputMaxValue from '../../../../Helpers/Formatters/InputMaxValue';

export default function DebtDetails(props) {

    return (
        <React.Fragment>
            <Row>
                <Col md={6}>
                    <Form.Group>
                        <TextInput
                            name="funeralIncome"
                            id="funeralIncome"
                            value={props.state.funeralIncome}
                            onChange={e => props.onFieldChange('funeralIncome', e.target.value)}
                            label="Funeral Expense (All funeral expenses)"
                            InputProps={{
                                inputComponent: InputMaxValue,
                                inputProps : { max: 25000 }
                            }}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <TextInput
                            name="morgage"
                            id="morgage"
                            value={props.state.morgage}
                            onChange={e => props.onFieldChange('morgage', e.target.value)}
                            label="Mortgage (Outstanding balance)"
                            InputProps={{
                                inputComponent: InputMaxValue,
                                inputProps : { max: 1000000 }
                            }}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <Form.Group>
                        <TextInput
                            name="otherDebt"
                            id="otherDebt"
                            value={props.state.otherDebt}
                            onChange={e => props.onFieldChange('otherDebt', e.target.value)}
                            label="Other Debt (All other debt balances)"
                            InputProps={{
                                inputComponent: InputMaxValue,
                                inputProps : { max: 500000 }
                            }}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <TextInput
                            name="monthlyDebt"
                            id="monthlyDebt"
                            value={props.state.monthlyDebt}
                            onChange={e => props.onFieldChange('monthlyDebt', e.target.value)}
                            label="Monthly Debt Payments (All)"
                            InputProps={{
                                inputComponent: InputMaxValue,
                                inputProps : { max: 50000 }
                            }}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <Form.Group>
                        <TextInput
                            name="educationExpense"
                            id="educationExpense"
                            value={props.state.educationExpense}
                            onChange={e => props.onFieldChange('educationExpense', e.target.value)}
                            label="Education Expense (Cost per child)"
                            InputProps={{
                                inputComponent: InputMaxValue,
                                inputProps : { max: 250000 }
                            }}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <TextInput
                            name="numberOfChildren"
                            id="numberOfChildren"
                            value={props.state.numberOfChildren}
                            onChange={e => props.onFieldChange('numberOfChildren', e.target.value)}
                            label="Number Children"
                            InputProps={{
                                inputComponent: InputMaxValue,
                                inputProps : { max: 10, isNumeric : true }
                            }}
                        />
                    </Form.Group>
                </Col>
            </Row>
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/PopUps/CoverageAmountPopUp/DebtDetails.js